/*
----------------------------
Module - notice-bar
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';

    /**
	* Helper: create cookie
	* @param cookieName: string
	* @param cookieValue string
	*/
	function createCookie(cookieName,cookieValue) {
		document.cookie = cookieName + "=" + cookieValue + "; expires=0";
	}
    
    fmg.noticebar = function() {
        
        function init() {

            var $notice_bar = $(".notice-bar");

            if ($notice_bar.length) {                
                var dismissButton = document.querySelector('.notice-bar__dismiss-btn');

                dismissButton.addEventListener('click', () => {
                    createCookie('site_notice_dismissed','1');
                    $('.notice-bar').css('display', 'none');
                });
            }
        }

        return {
            init: init
        };

    }();
        
    document.addEventListener("DOMContentLoaded", function () {
        fmg.noticebar.init();
    });

}());
